import { deleteRequest } from '@/core';
import { tripTemplates } from '@/requests';

export default async function deleteTripTemplateRequest(id) {
	let url = tripTemplates.getByIdPath(id);
	await deleteRequest(url);
}